import classNames from 'classnames';
import * as classes from './TextLink.css';
import { AriaRole, ComponentProps } from 'react';
import BaseTypography from '../BaseTypography';
import { Filter } from '@/types/app.type';

export interface TextLinkProps {
  'data-test-id'?: string;
  /**
   * Define the content of the TextLink.
   * @type string
   * @required
   */
  children: string;
  /**
   * Define the color of the TextLink.
   * @type ComponentProps<typeof BaseTypography>['color'];
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   * Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the font size of the TextLink.
   * @type "xs" | "s" | "m"
   * @optional
   * @default "s"
   */
  size: 'xs' | 's' | 'm';
  /**
   * Define the component type.
   * @type "span" | "p"
   * @optional
   */
  component?: keyof Pick<React.JSX.IntrinsicElements, 'span' | 'p'>;
  /**
   * Define the TextLink role.
   * @type "link" | "presentation" | "none"
   * @optional
   */
  role?: Filter<AriaRole, 'link' | 'presentation' | 'none'>;
  /**
   * Define the TextLink weightiness.
   * @type boolean
   * @optional
   * @default false
   */
  bold?: boolean;
}

export function TextLink(props: TextLinkProps) {
  return (
    <BaseTypography
      data-test-id={props['data-test-id']}
      role={props.role ?? 'presentation'}
      component={props.component ?? 'span'}
      color={props.color}
      className={classNames(classes.base, classes.variant(props.bold)[props.size], props.className)}
    >
      {props.children}
    </BaseTypography>
  );
}
